export const AI_EDITOR_ERROR_TEXTS = {
  timeout: 'Сервис недоступен или перегружен, попробуйте ещё раз',
  network:
    'Нет подключения к интернету, проверьте соединение и попробуйте снова',
  api: 'Произошла ошибка при обращении к сервису, попробуйте позже',
  empty:
    'Не удалось обработать ответ, попробуйте ещё раз или выберите другой стиль',
  unknown: 'Упс...Что-то пошло не так, повторите попытку',
} as const;

type AiEditorErrorKey = keyof typeof AI_EDITOR_ERROR_TEXTS;

export const getAiEditorErrorKey = (error: any): AiEditorErrorKey => {
  const status = error?.status;

  // 504 Gateway Timeout — nginx не дождался бэка
  if (status === 504) {
    return 'timeout';
  }

  // Нет сети
  if (error instanceof TypeError) {
    const msg = String(error.message || '');

    if (/Failed to fetch|NetworkError|Load failed/i.test(msg)) {
      return 'network';
    }
  }

  // Прочие 4xx/5xx
  if (status >= 400) {
    return 'api';
  }

  return 'unknown';
};
